module.exports = __webpack_public_path__ + "static/media/texture_3.c0061dc8.jpg";